import { render, staticRenderFns } from "./TabsEssence.vue?vue&type=template&id=6040ee22&scoped=true&"
import script from "./TabsEssence.vue?vue&type=script&lang=js&"
export * from "./TabsEssence.vue?vue&type=script&lang=js&"
import style0 from "./TabsEssence.vue?vue&type=style&index=0&id=6040ee22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6040ee22",
  null
  
)

export default component.exports